/* eslint-disable max-len */
import { REDIRECT_URL_KEY } from "constants/app.constant";
import appConfig from "configs/app.config";
import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { onSignInSuccess, onSignOutSuccess } from "store/auth/sessionSlice";
import { initialState, setUser } from "store/auth/userSlice";
import useQuery from "./useQuery";
import { get, post } from "helper";

function useAuth() {
    const dispatch = useDispatch();
    const query = useQuery();

    const navigate = useNavigate();

    const { fromQuery, fromElectron } = useSelector((state) => state.auth.user);
    const { token, signedIn } = useSelector((state) => state.auth.session);
    const [weather, setWeather] = useState();

    const handleAuth = async () => {
        try {
            const response = await post("/authentication/back-office/me");
            const { result: { user, tokens }, success } = response;
            if (!success) {
                signOut();
            }
            dispatch(onSignInSuccess(tokens));
            dispatch(
                setUser(
                    { authority: user?.roles?.map(el => el?.slug), ...user, fromQuery, fromElectron } || {
                        authority: ["USER"],
                        avatar: "",
                        email: ""
                    }
                )
            );
        } catch (error) {
            signOut();
        }

    };
    const fetchWeatherData = async () => {
        try {
            if(!signedIn) return;
            const { result } = await get("/weather");
            setWeather(result);
        } catch (error) {
            console.error("Error fetching weather data:", error);
        }
    };
    useEffect(() => {
        fetchWeatherData();
    }, []);

    const signIn = async (values) => {
        try {
            const { result, success, message } = await post("/authentication/back-office/login", values);
            if (!success) {
                return {
                    message,
                    status: "failed"
                };
            }
            const { user, tokens } = result;
            if(isEmpty(user?.roles))
                throw Error("Invalid role!");
            dispatch(onSignInSuccess(tokens));
            dispatch(
                setUser(
                    { authority: user?.roles?.map(el => el?.slug), ...user, fromQuery, fromElectron }
                )
            );
            const redirectUrl = query.get(REDIRECT_URL_KEY);
            navigate(
                redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath
            );
            return {
                message: "",
                status: "success"
            };

        } catch (errors) {
            return {
                message: errors?.response?.data?.message || errors.toString(),
                status: "failed"
            };
        }
    };

    const handleSignOut = () => {
        dispatch(onSignOutSuccess());
        dispatch(setUser(initialState));
        navigate(appConfig.unAuthenticatedEntryPath);
    };

    const signOut = async () => {
        handleSignOut();
    };

    return {
        authenticated: token && signedIn,
        handleAuth,
        signIn,
        fromQuery,
        fromElectron,
        signOut,
        weather

    };
}

export default useAuth;
